import { showMessage } from 'components/flashMessage/FlashMessage'

export function showNotification (config) {
  const defaultOptions = { message: null, duration: 6000, type: 'error', vertical: 'bottom', horizontal: 'left' }
  const options = { ...defaultOptions, ...config }
  showMessage(options)
}

export const alertHelper = {
  showNotification
}